// extracted by mini-css-extract-plugin
module.exports = {"content":"LoadingModal_content__qUvYS","text":"LoadingModal_text__N6OLI","wrapper":"LoadingModal_wrapper__348lN","spinner":"LoadingModal_spinner__Iz9ou"};